module.exports = __webpack_public_path__ + "img/2.a9e0ca55.png";